import { Icon } from '@cb/apricot-react'
import { profile } from '@myap/ui-library'

function ReturnToMyAP() {
  const { myapUIUrl } = profile()
  return (
    <div className="cb-margin-bottom-24">
      <a
        className="cb-btn cb-btn-naked cb-no-padding cb-btn-icon-left"
        href={`${myapUIUrl?.student}`}
      >
        <Icon name="west" className="cb-margin-right-8" /> Back to My AP
      </a>
    </div>
  )
}

export default ReturnToMyAP
